import React, { Fragment } from 'react';
import { IIncludedInContactIntervalStatus } from './interfaces';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const IncludedInContactIntervalStatus: React.FC<
  IIncludedInContactIntervalStatus
> = ({ status, label = false }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {status ? (
        <RemoveCircleOutlineIcon color="disabled" />
      ) : (
        <CheckCircleOutlineIcon color="info" />
      )}
      {label ? (
        <Typography
          variant="body2"
          sx={{
            ml: '.3em',
          }}
        >
          {status ? t('words.excluded') : t('words.included')}
        </Typography>
      ) : null}
    </Fragment>
  );
};
